import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService, AppConfig } from 'sigv-library';
import { ApiResponse } from '../models/api-response.model';
import { GetFieldSettingDisplayRes } from '../models/get-field-setting-display-res.model';

@Injectable({
  providedIn: 'root',
})
export class ApiWebSubmissionService extends ApiBaseService {
  constructor(protected appConfig: AppConfig, protected http: HttpClient) {
    super(appConfig.getApiUrl('webSubmission'), http);
  }

  /**
   * @description 取得欄位設定資料
   * @param request 查詢欄位設定資料的 companyId, productCode, useRole, useDevice
   * @returns 欄位設定資料
   */
  getFieldSettingDisplay(request: {
    companyId: string;
    productCode: string;
    useRole: string;
    useDevice: string;
  }): Observable<ApiResponse<GetFieldSettingDisplayRes>> {
    return this.doPost('/Submission/GetFieldSettingDisplay', request);
  }
}
